function getSafeRedirect(value) {
    if (typeof value !== 'string'
        || !value.startsWith('/')
        || value.startsWith('//')) {
        return undefined;
    }
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) {
        return undefined;
    }
    return `${url.pathname}${url.search}${url.hash}`;
}
let postLoginRedirect;
export function setPostLoginRedirect(value) {
    postLoginRedirect = value;
}
export function popPostLoginRedirect() {
    const value = postLoginRedirect;
    postLoginRedirect = undefined;
    if (!value) {
        return undefined;
    }
    if (value.type === 'internal') {
        return value;
    }
    const safeRedirect = getSafeRedirect(value.href);
    if (!safeRedirect) {
        return undefined;
    }
    return {
        ...value,
        href: safeRedirect,
    };
}
//# sourceMappingURL=PostLoginRedirect.js.map